import AvailabilityContainer from './availability-container';

export default AvailabilityContainer;
